module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('a', {
    attrs: {
      "id": "pl-2-2"
    }
  }), _vm._v("Also available in the Words of Wisdom series:")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('i', [_vm._v("The Architect Says")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Laura S. Dushkes")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("978-1-61689-093-3")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Princeton Architectural Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("37 East 7th Street, New York, New York 10003")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Visit our website at "), _c('a', {
    attrs: {
      "href": "http://www.papress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.papress.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("© 2013 Princeton Architectural Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Printed and bound in China")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("16 15 14 13 4 3 2 1 First edition")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("No part of this book may be used or reproduced in any manner without")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("written permission from the publisher, except in the context of reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Every reasonable attempt has been made to identify owners of copyright.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Errors or omissions will be corrected in subsequent editions.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Editor: Megan Carey")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Designer: Elana Schlenker")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Series designer: Paul Wagner")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Special thanks to: Nicola Bednarek Brower, Janet Behning, Fannie Bushin, Carina Cha,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Andrea Chlad, Benjamin English, Russell Fernandez, Will Foster, Jan Haux, Diane Levinson,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Jennifer Lippert, Jacob Moore, Katharine Myers, Margaret Rogalski, Dan Simon,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Sara Stemen, Andrew Stepanian, and Joseph Weston of Princeton Architectural Press")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("—Kevin C. Lippert, publisher")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Bader, Sara, editor of compilation.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The designer says : quotes, quips, and words of wisdom / compiled and edited by Sara Bader. — First edition.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("   pages cm. — (Words of wisdom)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-1-61689-134-3 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1. Design—Quotations. 2. Designers—Quotations. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("PN6084.D46B33 2013")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("745.4—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("2012043667")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1117ebab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_copyrighttitle.vue
// module id = 63
// module chunks = 0